import React, { useEffect } from 'react'
import {
  Route,
  BrowserRouter as Router,
  Routes,
  Navigate
} from "react-router-dom"
import {
  Box,
  CssBaseline,
  Toolbar,
} from '@mui/material'

import Aos from 'aos'
import 'aos/dist/aos.css'

import { AppProvider } from './context/context/context.js'
import ResponsiveAppBar from './components/navbar/navbar.js'
import Main from "./pages/main/main.js"
import About from "./pages/about/about.js"
import Reservation from "./pages/reservation/reservation.js"
import Gallery from './components/gallery/gallery.js'
import Offers from './pages/offers/offers.js'
import Footer from './components/footer/footer.js'

const App = () => {
  useEffect(() => {
    console.clear()
    
    console.log("%c MOHAMMED MEDHAT EL_ARABY PORTFOLIO",
      `color:#FAFAFA;
      font-size:75px;
      font-weight:bold;
      font-family: Calibri;`)

    Aos.init({ duration: 1000 })
  }, [])

  return <AppProvider>
    <React.Fragment>
      <CssBaseline />
      <Router>
        <Box sx={{ bgcolor: '#FFFFFF' }}>
          <ResponsiveAppBar />
          <Box py={1}/>
          <Toolbar />
          <Routes>
            <Route exact path='/' element={<Main />} />
            <Route exact path='/:work' element={<Gallery />} />
            <Route exact path='/about' element={<About />} />
            <Route exact path='/offers' element={<Offers />} />
            <Route exact path='/reservation' element={<Reservation />} />

            <Route path="*" element={<Navigate replace to="/about" />} />
          </Routes>
          <Toolbar />
          <Footer />
        </Box>
      </Router>
    </React.Fragment>
  </AppProvider>
}

export default App
